function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.5999 11.8999L2.56857 16.9521C1.88174 18.0968 2.06212 19.5621 3.00609 20.5061V20.5061C3.74431 21.2443 4.8215 21.5304 5.82872 21.2557L11.8999 19.5999",
  stroke: "#151515",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3999 11.8999L25.4312 16.9521C26.118 18.0968 25.9376 19.5621 24.9937 20.5061V20.5061C24.2554 21.2443 23.1783 21.5304 22.171 21.2557L16.0999 19.5999",
  stroke: "#151515",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.3411 11.2526C4.78528 10.5452 5.09873 9.5006 5.95222 9.21611L8.98441 8.20537C9.76633 7.94474 10.5903 8.46821 10.6866 9.28677L11.9 19.6002L5.3411 11.2526Z",
  stroke: "#02BC4D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6587 11.2526C23.2145 10.5452 22.901 9.5006 22.0475 9.21611L19.0153 8.20537C18.2334 7.94474 17.4094 8.46821 17.3131 9.28677L16.0998 19.6002L22.6587 11.2526Z",
  stroke: "#02BC4D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6234 8.11043C10.5576 7.51806 11.0213 7 11.6173 7H16.3827C16.9787 7 17.4424 7.51807 17.3766 8.11043L16.1 19.6H11.9L10.6234 8.11043Z",
  stroke: "#151515",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgCroissant = function SvgCroissant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCroissant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/croissant.f8e3d2ff.svg";
export { ForwardRef as ReactComponent };